import styled from 'styled-components';
import { TagLabelContainerStyled } from '@lerna-core';

export const DiscountPointsContainerStyled = styled.div`
  ${TagLabelContainerStyled} {
    font-weight: 400;
  }
`;
